import { createContext, useContext, useState, useCallback } from "react";
import { t } from "./translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    const fromUrl = new URLSearchParams(window.location.search).get("lang");
    if (fromUrl && ["es", "en", "it"].includes(fromUrl)) {
      localStorage.setItem("gyc-lang", fromUrl);
      return fromUrl;
    }
    const saved = localStorage.getItem("gyc-lang");
    return saved && ["es", "en", "it"].includes(saved) ? saved : "es";
  });

  const setLang = useCallback((code) => {
    setLangState(code);
    localStorage.setItem("gyc-lang", code);
    document.documentElement.lang = code;
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, setLang, copy: t[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
